<template>
    <div class="o-page__content u-pt-small">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 col-xl-12">
                    <h1 class="u-h3">Employee Attendance <span v-if="role_id==2">: Wilayah {{relation_name}}</span><span v-if="role_id==3">: Outlet {{relation_name}}</span></h1>
                    <div class="custom_toolbar">
                        <Select2 v-if="role_id==1||4" class="c-input" v-model="params.region" :options="regions" :settings="{ width: '100%', placeholder: 'All Region' }" @change="myChangeEvent($event)" @select="mySelectEvent($event)"/>
                        <Select2 v-if="role_id!=3" class="c-input" v-model="params.branch" :options="branches" :settings="{ width: '100%', placeholder: 'All Branch' }" @change="myChangeEvent2($event)"/>
                        <Select2 v-if="role_id!=3" class="c-input" v-model="params.outlet" :options="outlets" :settings="{ width: '100%', placeholder: 'All Outlet' }" @change="myChangeEvent3($event)"/>
                        <Select2 class="c-input" v-model="params.position" :options="positions" :settings="{ width: '100%', placeholder: 'All Position' }" @change="myChangeEvent4($event)"/>
                        <input type="text" placeholder="Search..." class="c-input" v-model="params.q" v-on:keyup="search">
                    </div>
                </div>
            </div>
            <div class="row u-mt-medium">
                <div class="col-12">
                    <vue-good-table v-loading="loading"
                        mode="remote"
                        :columns="columns"
                        :rows="rows"
                        :totalRows="totalRecords"
                        @on-page-change="onPageChange"
                        :select-options="{ 
                            enabled: true,
                            selectOnCheckboxOnly: true,
                            disableSelectInfo: true
                        }"
                        :pagination-options="{
                            enabled: true
                        }">
                        <template slot="table-row" slot-scope="props">
                            <span v-if="props.column.field == 'attendance'">
                                <el-switch :value="props.row.attendance==1 ? true : false" @change="switchChanged(props.row.npp)"></el-switch>
                            </span>
                            <span v-else-if="props.column.field == 'name'">
                                <el-row type="flex" justify="center">
                                    <el-col :span="4">
                                        <el-image 
                                            style="width: 40px; height: 40px; border-radius: 50%;"
                                            fit="cover"
                                            :src="props.row.image">
                                        </el-image>
                                    </el-col>
                                    <el-col :span="20">
                                        {{props.row.name.toUpperCase()}}<br/>
                                        <el-tag size="mini" type="success">{{props.row.npp}}</el-tag>
                                    </el-col>
                                </el-row>
                            </span>
                            <span v-else>
                                {{props.formattedRow[props.column.field]}}
                            </span>
                        </template>
                    </vue-good-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import 'vue-good-table/dist/vue-good-table.css'
    import { VueGoodTable } from 'vue-good-table';
    import api from '@/api/employees'
    import regions from '@/api/regions'
    import branches from '@/api/branches'
    import outlets from '@/api/outlets'
    import Select2 from 'v-select2-component';
    import { mapActions } from 'vuex';

    export default {
        components: {
            'vue-good-table':VueGoodTable,
            Select2
        },
        data() {
            return {
                role_id: localStorage.getItem('user_role_id'),
                relation_code: localStorage.getItem('relation_code'),
                relation_name: localStorage.getItem('relation_name'),
                dialogVisible: false,
                headers: {'x-api-key': 'BmSaBwIdYAgrljryhVxobDWM8ijDii4i', 'x-access-token': localStorage.getItem('accessToken')},
                rulesData: [{
                    name: 'npp',
                    rules: 'required, unique, max: 20 chars, min: 5 chars',
                },{
                    name: 'name',
                    rules: 'required',
                },{
                    name: 'outlet_code',
                    rules: 'required, registered in database outlets',
                },{
                    name: 'position',
                    rules: 'required',
                }],
                columns: [
                    {
                        label: 'Employee',
                        field: 'name'
                    },
                    {
                        label: 'Position',
                        field: 'position_name'
                    },
                    {
                        label: 'Outlet',
                        field: 'outlet_name'
                    },
                    {
                        label: 'Attendance',
                        field: 'attendance',
                        tdClass: 'u-text-center',
                        thClass: 'u-text-center',
                        width: '120px'
                    }
                ],
                rows: [],
                totalRecords: 0,
                page: 1,
                regions: [],
                branches: [],
                outlets: [],
                positions: [
                    {
                        id: '',
                        text: 'All Position'
                    },
                    {
                        id: 1,
                        text: 'Pimpinan'
                    },{
                        id: 2,
                        text: 'Customer Service'
                    },{
                        id: 3,
                        text: 'Teller'
                    },{
                        id: 4,
                        text: 'Satpam'
                    }
                ],
                params: {
                    q: '',
                    position: '',
                    region: localStorage.getItem('user_role_id') == 2 ? localStorage.getItem('relation_code') : '',
                    outlet: localStorage.getItem('user_role_id') == 3 ? localStorage.getItem('relation_code') : '',
                    branch: ''
                },
                loading: false,
                errorMessage: null
            }
        },
        created () {
            this.fetch();
            if(this.role_id==1||4){
                this.fetchRegions();
            }
            if(this.role_id==2){
                this.fetchBranches();
            }
        },
        methods: {
            ...mapActions([
                'logout'
            ]),
            fetch() {
                this.loading = true
                var self = this
                api.get(this.page, this.params.region, this.params.branch, this.params.outlet, this.params.q, this.params.position)
                .then(function (response) {
                    self.rows = response.data.data
                    self.totalRecords = response.data.meta.totalRecords
                    self.loading = false
                })
                .catch(function (error) {
                    self.loading = false
                    console.log(error);
                    if(error.response.status == 403){
                        self.logout()
                    }
                })
            },
            onPageChange(params) {
                console.log(params)
                this.page = params.currentPage
                this.fetch();
            },
            fetchRegions() {
                this.loading = true
                var self = this
                regions.getAll()
                .then(function (response) {
                    // 
                    var regionsx = [];
                    response.data.data.forEach(element => {
                        regionsx.push({
                            id: element.code,
                            text: element.name
                        });
                    });
                    self.regions = regionsx
                    self.loading = false
                    // console.log(self.regions)
                })
                .catch(function (error) {
                    console.log(error);
                    if(error.response.status == 403){
                        self.logout()
                    }
                })
            },
            fetchBranches() {
                var self = this
                branches.getAll(this.params.region)
                .then(function (response) {
                    // 
                    var regionsx = [];
                    response.data.data.forEach(element => {
                        regionsx.push({
                            id: element.code,
                            text: element.name
                        });
                    });
                    self.branches = regionsx
                    // console.log(self.branches)
                })
                .catch(function (error) {
                    console.log(error);
                    if(error.response.status == 403){
                        self.logout()
                    }
                })
            },
            fetchOutlets() {
                var self = this
                outlets.getAll(this.params.region, this.params.branch)
                .then(function (response) {
                    // 
                    var regionsx = [];
                    response.data.data.forEach(element => {
                        regionsx.push({
                            id: element.code,
                            text: element.name
                        });
                    });
                    self.outlets = regionsx
                    // console.log(self.outlets)
                })
                .catch(function (error) {
                    console.log(error);
                    if(error.response.status == 403){
                        self.logout()
                    }
                })
            },
            myChangeEvent(val){
                console.log(val);
                this.params.region = val
                this.params.branch = ''
                this.fetchBranches()
                this.fetch();
            },
            mySelectEvent({id, text}){
                console.log({id, text})
            },
            myChangeEvent2(val){
                console.log(val);
                this.params.branch = val
                this.params.outlet = ''
                this.fetchOutlets();
                this.fetch();
            },
            myChangeEvent3(val){
                console.log(val);
                this.params.outlet = val
                this.fetch();
            },
            myChangeEvent4(val){
                console.log(val);
                this.params.position = val
                this.fetch();
            },
            search() {
                this.fetch();
            },
            switchChanged(npp) {
                // console.log('switchChanged')
                // console.log(npp)
                var self = this
                api.setAttend(npp)
                .then(function (response) {
                    self.fetch()
                })
                .catch(function (error) {
                    console.log(error);
                    if(error.response.status == 403){
                        self.logout()
                    }
                })
            }
        },
    }
</script>

<style lang="scss" scoped>
.custom_toolbar {
    display: flex;
    div {
        margin-right: 10px;
    }
}
.el-row--flex.is-justify-center {
    align-items: center !important;
}
</style>